import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const SchoolDetail3 = () => {

	const App = useApp()
	const [menuOpen, setMenuOpen] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "초등학교 상세",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					{/* 지도 영역 */}
					<div style={{ height: "20rem", background: "#f5f5f5" }}></div>
					<div className={`${styles["school-list"]} flex-justify_between mt_40`}>
						<div>
							<i className="tag tag-box tag-gray">공립</i>
							<p className="mt_5">서울개원초등학교</p>
							<div className={`${styles["tag-area"]} mt_10`}>
								<span>#남녀공학</span>
							</div>
						</div>
						<div className={styles["call-btn"]}>
							<i className="icon icon_call" />
						</div>
					</div>
				</div>
			</div>
			<div className="padding">
				<ul className={`${styles["school-detail"]} accordion-list`}>
					<li onClick={() => setMenuOpen(0)} className={menuOpen === 0 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>기본정보</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<ul className={styles["user-info"]}>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_calendar icon mr_5" />
											<span>개교기념일 : 2000.09.14</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_daytime icon mr_5" />
											<span>주간</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_office icon mr_5" />
											<span>서울특별시 강남 서초 교육 지원청</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_mail icon mr_5" />
											<span>www.naver.com</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_call icon mr_5" />
											<span>032-1231-2341</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_place icon mr_5" />
											<span>인천광역시 서구 이음3로 130 관리동<i className="icon icon_copy ml_5" /></span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(1)} className={menuOpen === 1 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>학생</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>현황</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>학생 수</span>
										<span>1,049명</span>
									</div>
									<div>
										<span>학급 수</span>
										<span>39학급</span>
									</div>
									<div>
										<span>학급당 학생 수</span>
										<span>26.9명</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>학년별 학생 수(학급 수)</div>

								{/* 40% 미만일때 over-txt 클래스 추가 */}
								<ul className={`${styles["count-bar"]} ${styles.point} mt_20`}>
									<li>
										<span>1학년</span>
										<div className={styles.bar}>
											<span style={{ width: "80%" }}>
												<span>160명(8학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>2학년</span>
										<div className={styles.bar}>
											<span style={{ width: "60%" }}>
												<span>120(8학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>3학년</span>
										<div className={styles.bar}>
											<span style={{ width: "45%" }}>
												<span>80명(8학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>4학년</span>
										<div className={styles.bar}>
											<span style={{ width: "30%" }}>
												<span className={styles["over-txt"]}>60명(8학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>5학년</span>
										<div className={styles.bar}>
											<span style={{ width: "25%" }}>
												<span className={styles["over-txt"]}>40명(8학급)</span>
											</span>
										</div>
									</li>
									<li className={styles.on}>
										<span>6학년</span>
										<div className={styles.bar}>
											<span style={{ width: "70%" }}>
												<span>40명(8학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>기타</span>
										<div className={styles.bar}>
											<span style={{ width: "30%" }}>
												<span className={styles["over-txt"]}>60명(8학급)</span>
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(2)} className={menuOpen === 2 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>교직원</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>현황</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>교원 수</span>
										<span>77명</span>
									</div>
									<div>
										<span>휴직교원 수</span>
										<span>6명</span>
									</div>
									<div>
										<span>교원당 학생 수</span>
										<span>19.2명</span>
									</div>
								</div>
								<hr className="my_30" />
								<div className="flex-align_center">
									{/* 그래프 영역 */}
									<div style={{ width: "13rem", height: "13rem", background: "#eee" }} />
									<div className={`${styles["list-item"]} flex--item_1 ml_20`}>
										<div>
											<span>• 남 교직원</span>
											<span>30명</span>
										</div>
										<div>
											<span>• 여 교직원</span>
											<span>47명</span>
										</div>
									</div>
								</div>
								<ul className={`${styles["info-item"]} mt_30`}>
									<li>
										<div className="color-title">
											<p className="red">교장/교감</p>
										</div>
										<span>2명(남 1명/여 1명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="purple">수석/부장교사</p>
										</div>
										<span>4명(남 2명/여 2명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-blue">일반교사</p>
										</div>
										<span>1명(남 1명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="green">특수교사</p>
										</div>
										<span>1명(여 1명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="yellow">보건교사</p>
										</div>
										<span>1명(여 1명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="orange">영양교사</p>
										</div>
										<span>1명(여 1명)</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">원어민강사</p>
										</div>
										<span>-</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">강사/기간제교사</p>
										</div>
										<span>-</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">기타</p>
										</div>
										<span>-</span>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(3)} className={menuOpen === 3 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>시설</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>현황</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>강당</span>
										<span>1개</span>
									</div>
									<div>
										<span>체육관</span>
										<span>2개</span>
									</div>
									<div>
										<span>기숙사 재실인원</span>
										<span>50명</span>
									</div>
									<div>
										<span>수영장</span>
										<span>0개</span>
									</div>
									<div>
										<span>진로상담실</span>
										<span>3개</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>급식</div>
								<strong className="mt_30">급식 비율</strong>
								<div className={`${styles["bar-horizontal"]} mt_10`}>
									<div className={`${styles["bar-area"]} ml_0`}>
										<div className={styles.bar} style={{ background: "#d9d9d9" }}>
											<span style={{ width: "95%", background: "#57a7fb" }}>
												<span className={styles.percent}>95%</span>
											</span>
										</div>
									</div>
								</div>
								<div className={`${styles["list-item"]} mt_30`}>
									<div>
										<span>급식학생수</span>
										<span>124명</span>
									</div>
									<div>
										<span>배식장소</span>
										<span>교실+식당</span>
									</div>
									<div>
										<span>운영방식(업체)</span>
										<span>일부위탁(재원F&amp;S)</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>장애인 편의시설</div>
								<div className={`${styles["list-dots"]} mt_20`}>
									<div>
										<p className="text-blue">적정설치</p>
										<div className={styles.dots}>
											<div>주 출입구 접근로</div>
											<div>장애인 전용 주차구역 지정여부</div>
											<div>출입구(문) 설치여부</div>
										</div>
									</div>
									<div>
										<p className="text-blue">단순설치(1)</p>
										<div className={styles.dots}>
											<div>유도 및 안내설비 설치여부</div>
										</div>
									</div>
									<div>
										<p className="text-red">미설치(1)</p>
										<div className={styles.dots}>
											<div>경보 및 피난설비 설치여부</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(4)} className={menuOpen === 4 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>교육</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>방과후학교 운영</div>
								<ul className="my-info-box mt_20">
									<li>
										<span>프로그램 수</span>
										<span>19개</span>
									</li>
									<li>
										<span>참여 학생 수</span>
										<span>200명</span>
									</li>
								</ul>
								<strong className="mt_30">총 8,000,000원</strong>
								<ul className={`${styles["rate-percentage"]} mt_10`}>
									<li style={{ width: "50%" }}>
										<span>50%</span>
									</li>
									<li style={{ width: "50%", left: "50%" }}>
										<span>50%</span>
									</li>
								</ul>
								<ul className={`${styles["info-item"]} mt_30`}>
									<li>
										<div className="color-title">
											<p className="light-gray">수익자 부담 금액</p>
										</div>
										<span>4,000,000원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-blue">수익자 부담 외 지원 금액</p>
										</div>
										<span>4,000,000원</span>
									</li>
								</ul>
								<hr className="my_30" />
								<div>특색 교육 운영 여부</div>
								<div className={`${styles["list-dots"]} mt_20`}>
									<div>
										<p>운영</p>
										<div className={styles.dots}>
											<div>교과교실제</div>
											<div>수준별수업</div>
										</div>
									</div>
									<div>
										<p>미운영</p>
										<div className={styles.dots}>
											<div>영어교육프로그램</div>
											<div>자율학교</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(5)} className={menuOpen === 5 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>결산</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>지출내역</div>
								<strong className="mt_30">총 1,982,556,225원</strong>
								<div className={`${styles["spending-bar"]} mt_10`}>
									<div style={{ width: "10%", background: "#b898ff", left: "90%" }} />
									<div style={{ width: "20%", background: "#ff9326", left: "70%" }} />
									<div style={{ width: "15%", background: "#ffce69", left: "55%" }} />
									<div style={{ width: "15%", background: "#16d79b", left: "40%" }} />
									<div style={{ width: "40%", background: "#57a7fb" }} />
								</div>
								<ul className={`${styles["info-item"]} mt_30`}>
									<li>
										<div className="color-title">
											<p className="light-blue">학생복지/교육격차 해소</p>
										</div>
										<span>655,611,715원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="green">학교 일반운영</p>
										</div>
										<span>541,238,323원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="yellow">기본적 교육활동</p>
										</div>
										<span>541,238,323원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="orange">교육활동 지원</p>
										</div>
										<span>541,238,323원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="purple">선택적 교육활동</p>
										</div>
										<span>541,238,323원</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">인적자원운용</p>
										</div>
										<span>-</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">학교시설확충</p>
										</div>
										<span>-</span>
									</li>
									<li>
										<div className="color-title">
											<p className="light-gray">학교재무활동</p>
										</div>
										<span>-</span>
									</li>
								</ul>
							</div>
						</div>
					</li>
				</ul>

				<div className={`${styles["guide-bottom"]} mt_40`}>학교 알리미에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default SchoolDetail3